import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import { Link } from "react-router-dom";

export class TermsCondition extends Component {
  componentDidMount() {
    document.title = "JCA - Terms & Conditions";
  }
  render() {
    return (
      <div>
        <h1 className="heading">Terms & Conditions</h1>
        <h3 className="heading3">JCA Mobile Application</h3>
        <Paper className="paper" elevation={3}>
          <ol className="ol">
            <li>
              <b>Scope:</b>
              <ol>
                <li>
                  JCA is a mobile application (“Application”), operated by
                  Reliance Retail Limited and/or its affiliates (“Company”,
                  “we,” “us” and “our”) located at – 3rd Floor, Court House,
                  Lokmanya Tilak Marg, Dhobi Talao, Mumbai – 400002 India and
                  developed by Jio Platforms Limited.
                </li>
                <li>
                  The Application is designed to help Jio Customer Associates
                  and Jio Local Distributors who are partners of the Company.
                  <br></br>
                  The Jio Customer Associates may avail the services provided by
                  the Application to:
                  <ul>
                    <ol style={{ marginBottom: "10px" }}>
                      (i) view details of Jio associates mapped to them;
                    </ol>
                    <ol style={{ marginBottom: "10px" }}>
                      (ii) generate dashboard to monitor sales performance of
                      Jio associates on the basis of activation and recharge
                      done by them;
                    </ol>
                    <ol style={{ marginBottom: "10px" }}>
                      (iii) communicate with the Jio associates through call or
                      WhatsApp;
                    </ol>
                  </ul>
                  The Jio Local Distributor may avail the services provided by
                  the Application to:
                  <ul>
                    <ol style={{ marginBottom: "10px" }}>
                      (iv) place order for devices including but not limited to
                      JioBharat phones, SIM cards and recharges provided by the
                      Company;
                    </ol>
                    <ol style={{ marginBottom: "10px" }}>
                      (v) make payment to the Company for the order placed
                      either through UPI, credit card or wallet;
                    </ol>
                    <ol style={{ marginBottom: "10px" }}>
                      (vi) and any other services provided by the Company from
                      time to time (“Services”) on any compatible smart phones
                      powered by Android (“Device”).
                    </ol>
                  </ul>
                </li>
                <li>
                  Your (“you”, “your” or “user”) use of the Application is
                  subject to these terms and conditions (“Terms”).
                </li>
                <li>
                  Your use of the Application requires that you agree to these
                  Terms and the privacy policy of the Application. By
                  registering or signing up to the Application, or otherwise
                  having access to, receiving, and/or using the Application, you
                  acknowledge to have read, understood and you consent to be
                  governed and bound by these Terms and the privacy policy of
                  the Application. If you do not understand the Terms or the
                  privacy policy of the Application, or do not accept any part
                  of them, then you should not use the Application.
                </li>
                <li>
                  These Terms should be read in consonance with your enterprise
                  employment terms and conditions.
                </li>
                <li>
                  The Terms are an electronic record in terms of the Information
                  Technology Act, 2000 (as amended / re-enacted) (“IT Act") and
                  rules thereunder, and is published in accordance with the
                  provisions of Rule 3 (1) of Information Technology
                  (Intermediaries Guidelines and Digital Media Ethics code)
                  Rules, 2021 which mandates for publishing of rules and
                  regulations, privacy policy and terms of use for access or
                  usage of Application. This electronic record is generated by a
                  computer system and does not require any physical or digital
                  signatures.
                </li>
              </ol>
            </li>

            <li>
              <b>Privacy and Protection of Personal Information:</b>
              <ol>
                <li>
                  Please refer to the privacy policy of the Application
                  available
                  <Link to="/privacy-policy">[here]</Link>.
                </li>
                <li>
                  Please note that your use of the Application or Services on
                  your Device and download thereof from Google play store may be
                  subject to the respective privacy policies as may be published
                  or made available by the Device and Google play store.
                </li>
              </ol>
            </li>
            <li>
              <b>Modifications:</b>
              <ol>
                <li>
                  <b>Modifications of the Terms</b>: The Company reserves the
                  right to change the Terms under which the Services are
                  offered, including but not limited to the charges, if any,
                  associated with the use of the Services. The Terms may be
                  further modified based on changes in the business, legal and
                  regulatory requirements and will be updated online. We will
                  make communicate any changes to these Terms to you. You are
                  encouraged to periodically visit this page to review these
                  Terms and any changes to it.
                </li>
                <li>
                  <b>Modification of Services</b>:The Company reserves the right
                  to add, modify or delete any content or features available in
                  the Services at any time at its sole discretion.
                </li>
              </ol>
            </li>
            <li>
              <b>Links to Third Party Sites and Applications:</b>
              <ol>
                <li>
                  The Application may contain links to other web
                  sites/applications ("Linked Sites"). The Linked Sites are not
                  under the control of the Company and the Company is not
                  responsible for the contents of any Linked Site, including
                  without limitation any link contained in a Linked Site, or any
                  changes or updates to a Linked Site or any information
                  transmitted on a Linked Site. The inclusion of any link does
                  not imply endorsement by the Company of the site or any
                  association with its operators.
                </li>
                <li>
                  Any dealings with third parties (including advertisers)
                  included within or available via a link from the Application
                  or participation in promotions, including the delivery of and
                  the payment for goods and services, and any other terms,
                  conditions, warranties or representations associated with such
                  dealings or promotions, are solely between you and the
                  advertiser or other third party. The Company shall not be
                  responsible or liable for any part of any such dealings or
                  promotions.
                </li>
                <li>
                  You acknowledge and agree that the use of any Linked Sites is
                  governed by such third party’s terms of use, license
                  agreement, privacy policy, or other such agreement. The
                  Company disclaims any and all responsibility for any
                  disclosure of information or any other practices of any third
                  party. The Company expressly disclaims any warranty with
                  respect to your personal or other information that may be
                  collected, processed, shared or retained by any third party.
                </li>
              </ol>
            </li>
            <li>
              <b>Intellectual Property Rights:</b>
              <ol>
                <li>
                  The Company shall own title, interest and rights, including
                  all related intellectual property rights, in/of the
                  Application including but not limited to object code of the
                  Application, features of services, which is/are protected by
                  the applicable laws except the content owned by the user. You
                  acknowledge that such ownership shall include all intellectual
                  property rights arising from any suggestions, enhancement
                  requests, recommendations or other information provided by the
                  user, whether in the course of use of the Application, your
                  device or otherwise.
                </li>
              </ol>
            </li>
            <li>
              <b>Use Limitations:</b>
              <ol>
                <li>
                  Services offered by the Application are intended solely for
                  the purpose of availing Services provided by the Application.
                  You may not distribute, transmit, display, perform, reproduce,
                  publish, license, create derivative works from, transfer, or
                  sell any information, software, products or Services offered
                  by the Application.
                </li>
                <li>
                  As a condition of your use of the Application, you warrant to
                  the Company that you will not use the Application for any
                  purpose that is commercial, unlawful or prohibited by these
                  Terms. You may not use the Application in any manner which
                  could damage, disable, overburden or impair the Services or
                  interfere with any other party's use and enjoyment of the
                  Application. You are not entitled to use any kind of measures,
                  mechanisms or tools (software or hardware) that could
                  interfere with the functioning of the Application or any of
                  its Services.
                </li>

                <li>
                  You are not entitled to use any kind of measures, mechanisms
                  or tools (software or hardware) that could interfere with the
                  functioning of the Application or any of its Services.
                </li>
                <li>
                  You may not use the Services and/or Application if you are
                  under the age of 18 years.
                </li>
              </ol>
            </li>
            <li>
              <b>General:</b>
              <ol>
                <li>
                  You may be required to register in order to access Application
                  using the means and methodology as provided by the Company
                  from time to time.
                </li>
                <li>
                  By using our Services you hereby agree to ensure that the
                  explicit prohibitions mentioned in section 7.4 are at all
                  times adhered to.
                </li>
                <li>
                  Use Restriction: You must not access the Application if you
                  are a person who is either barred or otherwise legally
                  prohibited from receiving or using the Service or any Services
                  under the laws of India.
                </li>
                <li>
                  You shall not host, display, upload, modify, publish,
                  transmit, update or share any information which:
                  <ol className="lower-alpha">
                    <li>
                      belongs to another person and to which the user does not
                      have any right;
                    </li>
                    <li>
                      is obscene, pornographic, paedophilic, invasive of
                      another’s privacy including bodily privacy, insulting or
                      harassing on the basis of gender, racially or ethnically
                      objectionable, relating or encouraging money laundering or
                      gambling, or an online game that causes user harm, or
                      promoting enmity between different groups on the grounds
                      of religion or caste with the intent to incite violence;
                    </li>
                    <li>is harmful to child;</li>
                    <li>
                      infringes any patent, trademark, copyright or other
                      proprietary rights;
                    </li>
                    <li>
                      deceives or misleads the addressee about the origin of the
                      message or knowingly and intentionally communicates any
                      misinformation or information which is patently false and
                      untrue or misleading in nature or, in respect of any
                      business of the Central Government, is identified as fake
                      or false or misleading by such fact check unit of the
                      Central Government as the Ministry may, by notification
                      published in the Official Gazette, specify;
                    </li>
                    <li>impersonates another person;</li>
                    <li>
                      threatens the unity, integrity, defence, security or
                      sovereignty of India, friendly relations with foreign
                      States, or public order, or causes incitement to the
                      commission of any cognizable offence, or prevents
                      investigation of any offence, or is insulting other
                      nation;
                    </li>
                    <li>
                      contains software virus or any other computer code, file
                      or program designed to interrupt, destroy or limit the
                      functionality of any computer resource;
                    </li>
                    <li>
                      is in the nature of an online game that is not verified as
                      a permissible online game;
                    </li>
                    <li>
                      is in the nature of advertisement or surrogate
                      advertisement or promotion of an online game that is not a
                      permissible online game, or of any online gaming
                      intermediary offering such an online game;
                    </li>
                    <li>violates any law for the time being in force;</li>
                    <li>
                      Provides instructional information about illegal
                      activities such as making and/ or buying illegal weapons,
                      violating someone’s privacy, or providing or creating
                      computer viruses;
                    </li>
                  </ol>
                </li>
                <li>
                  Services may be made available for free of cost or for a
                  specified cost as may be decided by the Company from time to
                  time.
                </li>
                <li>
                  Third-Party Fees: You may incur access or data fees from third
                  parties (such as your internet provider or mobile carrier) in
                  connection with your use of Services and of Application. You
                  are solely responsible for all such fees.
                </li>
                <li>
                  Updates: Services originating from the Application may
                  communicate with the servers from time to time to check for
                  available updates to the Services and to the functionality of
                  the Application, such as bug fixes, patches, enhanced
                  functions, missing plug-ins and new versions (collectively,
                  "Updates"). Your use of the Services you have installed
                  requires that you have agreed to receive such automatically
                  requested Updates.
                </li>
                <li>
                  Accuracy of Information: You agree that the information
                  entered by you while profile creation/ updation or using any
                  of Services is true, current, complete and accurate in all
                  respects. The Company is not responsible for any losses
                  arising out of discrepancy in your data. You are solely
                  responsible for maintaining confidentiality and security of
                  your user account and for all activities that occur on or
                  through your user account. The Company is not responsible for
                  any losses arising out of the unauthorized use of your user
                  account.
                </li>
                <li>
                  The user agrees and acknowledges that the Company shall send
                  commercial communication to the user in relation to the
                  Services availed by the Company.{" "}
                </li>
              </ol>
            </li>
            <li>
              <b>LIABILITY DISCLAIMER:</b>
              <ol>
                <li>
                  TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT
                  SHALL THE COMPANY BE LIABLE TO YOU FOR ANY SPECIAL,
                  INCIDENTAL, INDIRECT, PUNITIVE OR CONSEQUENTIAL DAMAGES
                  WHATSOEVER (INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF
                  USE, LOSS OF BUSINESS PROFITS, BUSINESS INTERRUPTION, LOSS OF
                  INFORMATION, OR ANY OTHER PECUNIARY LOSS) ARISING OUT OF THE
                  USE OF, OR INABILITY TO USE OR ACCESS, THE APPLICATION OR FOR
                  ANY SECURITY BREACH OR ANY VIRUS, BUG, UNAUTHORIZED
                  INTERVENTION, DEFECT, OR TECHNICAL MALFUNCTIONING OF THE
                  APPLICATION, WHETHER OR NOT FORESEEABLE OR WHETHER OR NOT THE
                  COMPANY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES,
                  OR BASED ON ANY THEORY OF LIABILITY, INCLUDING BREACH OF
                  CONTRACT OR WARRANTY, NEGLIGENCE OR OTHER TORTIOUS ACTION, OR
                  ANY OTHER CLAIM ARISING OUT, OF OR IN CONNECTION WITH, YOUR
                  USE OF, OR ACCESS TO, THE APPLICATION OR THE CONTENT. FURTHER,
                  THE COMPANY SHALL NOT BE LIABLE TO YOU FOR ANY TEMPORARY
                  DISABLEMENT, PERMANENT DISCONTINUANCE OR MODIFICATION OF THE
                  APPLICATION BY THE COMPANY OR FOR ANY CONSEQUENCES RESULTING
                  FROM SUCH ACTIONS.
                </li>
                <li>
                  YOU SHALL BE SOLELY RESPONSIBLE FOR OBTAINING AND MAINTAINING
                  ANY EQUIPMENT AND ANCILLARY SERVICES (INCLUDING THE PAYMENT OF
                  ANY ADDITIONAL FEES THEREFORE) REQUIRED TO CONNECT TO, ACCESS
                  OR OTHERWISE USE THE SERVICES, INCLUDING, WITHOUT LIMITATION,
                  MODEMS, HARDWARE, SERVERS, SOFTWARE, OPERATING SYSTEMS,
                  NETWORKING, WEB SERVERS, INTERNET AND TELEPHONE SERVICE
                  (COLLECTIVELY, “EQUIPMENT”). YOU WILL ALSO BE RESPONSIBLE FOR
                  MAINTAINING THE SECURITY OF THE EQUIPMENT AND FOR ALL USES OF
                  THE EQUIPMENT WITH OR WITHOUT YOUR KNOWLEDGE OR CONSENT.
                </li>
                <li>
                  YOU ARE SOLELY RESPONSIBLE FOR THE CONTENT AND OTHER MATERIALS
                  YOU TRANSMIT THROUGH THE SERVICE OR SHARE WITH OTHER USERS OR
                  RECIPIENTS. YOU WILL NOT TRANSMIT ANY CONTENT THAT YOU DID NOT
                  CREATE OR THAT YOU DO NOT OWN ALL RIGHT, TITLE AND INTEREST IN
                  AND TO, INCLUDING, WITHOUT LIMITATION, ALL COPYRIGHT AND
                  RIGHTS OF PUBLICITY CONTAINED THEREIN.
                </li>
                <li>
                  THE COMPANY AND/OR ITS RESPECTIVE AFFILIATES MAKES NO
                  REPRESENTATIONS ABOUT THE SUITABILITY, RELIABILITY,
                  AVAILABILITY, TIMELINESS AND ACCURACY OF THE INFORMATION,
                  SOFTWARE AND SERVICES AND RELATED CONTENT CONTAINED ON THE
                  APPLICATION FOR ANY PURPOSE. ALL SUCH INFORMATION, SOFTWARE
                  AND SERVICES AND RELATED CONTENT ARE PROVIDED "AS IS" WITHOUT
                  WARRANTY OF ANY KIND. THE COMPANY AND/OR ITS RESPECTIVE
                  SUPPLIERS HEREBY DISCLAIMS ALL WARRANTIES AND CONDITIONS WITH
                  REGARD TO THIS INFORMATION, SOFTWARE, AND SERVICES AND RELATED
                  CONTENT, INCLUDING ALL IMPLIED WARRANTIES AND CONDITIONS OF
                  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND
                  NON-INFRINGEMENT.
                </li>
                <li>
                  YOU SPECIFICALLY AGREE THAT THE COMPANY SHALL NOT BE
                  RESPONSIBLE FOR UNAUTHORISED ACCESS TO OR ALTERATION OF YOUR
                  TRANSMISSIONS OR DATA, ANY MATERIAL OR DATA SENT OR RECEIVED
                  OR NOT SENT OR RECEIVED, OR ANY TRANSACTIONS ENTERED INTO
                  THROUGH THE APPLICATION. YOU SPECIFICALLY AGREE THAT THE
                  COMPANY IS NOT RESPONSIBLE OR LIABLE FOR ANY THREATENING,
                  DEFAMATORY, OBSCENE, OFFENSIVE OR ILLEGAL SERVICES OR CONDUCT
                  OF ANY OTHER PARTY OR ANY INFRINGEMENT OF ANOTHER'S RIGHTS,
                  INCLUDING INTELLECTUAL PROPERTY RIGHTS. YOU SPECIFICALLY AGREE
                  THAT THE COMPANY IS NOT RESPONSIBLE FOR ANY SERVICES SENT
                  USING AND/OR INCLUDED IN THE APPLICATION BY ANY THIRD PARTY.
                </li>
              </ol>
            </li>

            <li>
              <b>TERMINATION (TEMPORARY AND PERMANENT DISABLEMENT):</b>
              <ol>
                <li>
                  Unless otherwise provided in these Terms, the Services offered
                  to you may be terminated by the Company without assigning any
                  reasons at any time at the sole discretion of the Company.
                  Upon termination / suspension, you shall not have the right to
                  use or access the Application/Services.
                </li>
                <li>
                  The Company reserves the right to suspend and/ or terminate
                  your access to the Services in case of any non-adherence to
                  these Terms and Conditions by you.{" "}
                </li>
              </ol>
            </li>
            <li>
              <b>GOVERNING LAW AND DISPUTE RESOLUTION:</b>
              <ol>
                <li>
                  These terms and conditions are governed and construed in
                  accordance with the laws of India. The courts in Mumbai shall
                  have exclusive jurisdiction to hear disputes arising out of
                  these terms.
                </li>
              </ol>
            </li>
            <li>
              <b>FORCE MAJEURE:</b>
              <ol>
                <li>
                  The Company shall be under no liability whatsoever in the
                  event of non-availability of any portion of the Application or
                  subscribed content occasioned by act of God, war, disease,
                  revolution, riot, civil commotion, strike, lockout, flood,
                  fire, failure of any public utility, manmade disaster,
                  infrastructure failure or any other cause whatsoever beyond
                  the control of the Company.
                </li>
              </ol>
            </li>
            <li>
              <b>SEVERABILITY:</b>
              <ol>
                <li>
                  If any of the provisions of these Terms are deemed invalid,
                  void, or for any reason unenforceable, that part of these
                  Terms will be deemed severable and will not affect the
                  validity and enforceability of any remaining provisions of
                  these Terms.
                </li>
              </ol>
            </li>
            {/* <li>
              <b>CONTACT DETAILS:</b>
              <div className="contact-details">
                <p>
                  Email: <a href="mailto:"></a>
                </p>
                <p>
                  Contact No: <a href="tel:"></a>
                </p>
              </div>
            </li> */}
          </ol>
        </Paper>
      </div>
    );
  }
}

export default TermsCondition;
